<template>
  <el-alert
    :title="title"
    :type="type"
    :description="description"
    :closable="false"
    show-icon
  >
    <slot name="description" />
  </el-alert>
</template>

<script>
export default {
  name: "EdAlert",
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    type: {
      type: String,
      required: false,
      default: "success",
    },
    description: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {},
  watch: {},
};
</script>



// WEBPACK FOOTER //
// EdAlert.vue?a2760296